import { render, staticRenderFns } from "./ArticleReportResponse.vue?vue&type=template&id=ff92fd2c&"
import script from "./ArticleReportResponse.vue?vue&type=script&lang=js&"
export * from "./ArticleReportResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports